<template>
  <div>
    <v-card-title>
      <v-btn
        color="primary"
        @click="cadastrarGradeProduto"
        outlined
        v-if="$helper.verificaPermissao('cadastrar-grade-produto') && botaoCadastro == true"
        >Cadastrar</v-btn
      >
      <v-spacer></v-spacer>
      <!-- <v-text-field
        outlined
        dense
        v-model="search"
        append-icon="search"
        label="Pesquisar"
        single-line
        hide-details
      >
      </v-text-field> -->
    </v-card-title>
    <v-card-text>
      <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th>Grade 1</th>
                <th>Grade 2</th>
                <th>Estoque</th>
                <th>Código de Barra</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="g in getGradesProduto" :key="g.id">
                <td>{{g.grade_1}}</td>
                <td>{{g.grade_2}}</td>
                <td>{{g.quantidade_estoque}}</td>
                <td>{{g.codigo_barra}}</td>
                <td>

                  <v-btn
                    color="primary"
                    outlined
                    small
                    @click="visualizarGradeProduto(g)"
                    v-if="$helper.verificaPermissao('visualizar-grade-produto') && botaoVisualizar == true"
                    >Visualizar</v-btn
                  >
                  <v-btn
                    color="success"
                    outlined
                    small
                    @click="_setProdutoVenda(g)"
                    v-if="botaoAdicionarVenda == true"
                    >Adicionar</v-btn
                  >
                  <v-btn
                    color="success"
                    outlined
                    small
                    @click="_setProduto(g)"
                    v-if="botaoAdicionarProduto == true"
                    >Adicionar</v-btn
                  >
                </td>
              </tr>
            </tbody>
          </template>
      </v-simple-table>
    </v-card-text>
    <ModalCadastro />
  </div>
</template>

<script>
import ModalCadastro from "@/pages/produto/grade/ModalCadastro";
import { mapGetters, mapActions } from "vuex";

export default {
  props: {
    botaoAdicionarVenda: false,
    botaoAdicionarProduto: false,
    botaoCadastro: false,
    botaoVisualizar: false,
    listarGrades: false,
  },

  components: {
    ModalCadastro,
  },
  data() {
    return {
      search: "",
      headers: [
        { text: "#", value: "id" },
        { text: "Grade 1", value: "grade_1" },
        { text: "Grade 2", value: "grade_2" },
        { text: "Cód. de Barra", value: "codigo_barra" },
        { text: "Quant. Estoque", value: "_quantidade_estoque" },
        { text: "Ações", value: "action", sortable: false },
      ],
    };
  },
  computed: {
    ...mapGetters(["getGradesProduto", 'getProduto', 'getProdutoVenda']),
  },
  methods: {
    ...mapActions([
      "listarGradeProduto",
      "visualizarGradeProduto",
      "cadastrarGradeProduto",
      'setModalListarGradeProduto'
    ]),
    _setProdutoVenda(item){
      let produtoVenda = {
        ...this.getProdutoVenda, 
        descricao: `${this.getProdutoVenda.descricao} ${item.grade_1 ? '- ' + item.grade_1 : ''}${item.grade_2 ? '/' + item.grade_2 : ''}`,
        grade_id: item.id
      }

      this.$store.commit('setProdutoVenda', {
        ...produtoVenda,
      })

      setTimeout(() => {
        this.setModalListarGradeProduto(false)
      }, 50)
    },
    _setProduto(item){ 
      let produto = {
         ...this.getProduto, 
        descricao: `${this.getProduto.descricao} ${item.grade_1 ? '- ' + item.grade_1 : ''}${item.grade_2 ? '/' + item.grade_2 : ''}`,
        grade_id: item.id
      }

      this.$store.commit('setProduto', {
        ...produto,
      })

      setTimeout(() => {
        this.setModalListarGradeProduto(false)
      }, 50)
    }
  },
  created() {
    if(this.listarGrades){
      this.listarGradeProduto({produto_id: this.getProduto.id});
    }
  },
};
</script>
